import useAPI from "./useAPI";
import React from "react";

export default function useAdminListPartners(props) {
  const { onSave } = props;

  const { query: deletePartner } = useAPI({
    type: "delete",
    url: `partner`,
    defer: true,
  });

  const handleDelete = async (partnerId) => {
    try {
      if (
        !window.confirm(`Êtes-vous sûr de vouloir supprimer ce partenaire ?`)
      ) {
        return;
      }

      await deletePartner({
        url: `partner/${partnerId}`,
      });

      onSave({ success: true, message: "Partenaire supprimé avec succès" });
    } catch (error) {
      console.error("Error deleting partner:", error);
      throw error;
    }
  };

  return {
    ...props,
    handleDelete,
  };
}
